import config from 'config'

const customerApi = `${config.apiHost}`

export default {
    getStaffTaskStatList: {
        url: `${customerApi}/oem-task-system/api/task-statistics/by-staff`,
        type: 'GET',
    },

    exportData: {
        url: `${customerApi}/oem-task-system/api/task-statistics/by-staff/export`,
        type: 'GET',
    },
}
